import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";

import News from "./pages/News";
import Dogs from "./pages/Dogs";
import Litters from "./pages/Litters";
import Contacts from "./pages/Contacts";
import Maintenance from "./pages/Maintenance";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import NavBar from "./components/NavBar/NavBar";
import Sidebar from "./components/Sidebar/Sidebar";
import { SingleNews } from "./pages/SingleNews";
import { SingleDog } from "./pages/SingleDog";
import { SingleLitter } from "./pages/SingleLitter";
import { SinglePuppy } from "./pages/SinglePuppy";
import { getSettings } from "./services";

const App = () => {
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    getSettings().then((response) => {
      setMaintenance(response.data.maintenance);
    });
  }, []);

  // if (maintenance) {
  //   return <Maintenance />;
  // }

  return (
    <Router>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {/* Hero Header */}
        <Header />

        {/* Sticky Navigation Bar */}
        <NavBar />

        {/* Full-width wrapper: background images + constrained content */}
        <Box sx={{ flex: 1, position: "relative", overflow: "hidden" }}>
          {/* Background images — full viewport width, 550px tall, no padding */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "550px",
              zIndex: 0,
              pointerEvents: "none",
              background: `url('/images/bg_left.png') left center/auto 100% no-repeat, url('/images/bg_right.png') right center/auto 100% no-repeat`,
            }}
          />

          {/* Main Content Area: Sidebar + Page */}
          <Box
            sx={{
              maxWidth: 1200,
              width: "100%",
              mx: "auto",
              px: { xs: 2, md: 3 },
              py: 3,
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 3,
              position: "relative",
              zIndex: 1,
            }}
          >
            {/* Left Sidebar */}
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Sidebar />
            </Box>

            {/* Main Content */}
            <Box component="main" sx={{ flex: 1, minWidth: 0 }}>
              <Routes>
                <Route path="/" element={<News />} />
                <Route path="/dogs" element={<Dogs />} />
                <Route path="/dogs/:id" element={<SingleDog />} />
                <Route path="/puppies" element={<Litters />} />
                <Route path="/puppies/:id" element={<SingleLitter />} />
                <Route path="/puppy/:id" element={<SinglePuppy />} />
                <Route path="/contacts" element={<Contacts />} />
                <Route path="/news/:id" element={<SingleNews />} />
              </Routes>
            </Box>
          </Box>
        </Box>

        <Footer />
      </Box>
    </Router>
  );
};

export default App;
